import { SET_DATA_FILTERS } from '../dataFilters/actionTypes';
import {
  Frequencies,
  ReportingPlatformActions,
  ReportingPlatformState,
} from './types';

export const initialState: ReportingPlatformState = {
  hasGeneratingReports: false,
  reports: [],
  isLoading: false,
  isError: false,
  isFirstTimeLoaded: false,
  reportsPagination: {
    currentPage: 1,
  },
  scheduledReports: {
    reports: [],
    isLoading: false,
    isFirstTimeLoaded: false,
    isError: false,
    currentPage: 1,
    filter: {},
    isDeleting: {},
    isDeletingError: false,
  },
};

export const API_CREATE_REPORT = 'REPORTING_PLATFORM_API_CREATE_REPORT';
export const API_CREATE_REPORT_REQUEST =
  'REPORTING_PLATFORM_API_CREATE_REPORT_REQUEST';
export const API_CREATE_REPORT_SUCCESS =
  'REPORTING_PLATFORM_API_CREATE_REPORT_SUCCESS';
export const API_CREATE_REPORT_FAILURE =
  'REPORTING_PLATFORM_API_CREATE_REPORT_FAILURE';

export const API_GET_REPORT = 'REPORTING_PLATFORM_API_GET_REPORT';

export const API_GET_REPORTS = 'REPORTING_PLATFORM_API_GET_REPORTS';
export const API_GET_REPORTS_REQUEST =
  'REPORTING_PLATFORM_API_GET_REPORTS_REQUEST';
export const API_GET_REPORTS_SUCCESS =
  'REPORTING_PLATFORM_API_GET_REPORTS_SUCCESS';
export const API_GET_REPORTS_FAILURE =
  'REPORTING_PLATFORM_API_GET_REPORTS_FAILURE';

export const NEW_REPORT_INIT = 'REPORTING_PLATFORM_NEW_REPORT_INIT';
export const NEW_REPORT_SET_PERIOD = 'REPORTING_PLATFORM_NEW_REPORT_SET_PERIOD';
export const NEW_REPORT_SET_FREQUENCY =
  'REPORTING_PLATFORM_NEW_REPORT_SET_FREQUENCY';
export const NEW_REPORT_SET_SITES = 'REPORTING_PLATFORM_NEW_REPORT_SET_SITES';
export const NEW_REPORT_SET_RECIPIENTS =
  'REPORTING_PLATFORM_NEW_REPORT_SET_RECIPIENTS';
export const RESET_REPORT = 'REPORTING_PLATFORM_RESET_REPORT';
export const RESET_REPORT_FREQUENCY =
  'REPORTING_PLATFORM_RESET_REPORT_FREQUENCY';

export const NEW_REPORT_CLEAR_SUCCESS_BANNER =
  'REPORTING_PLATFORM_NEW_REPORT_CLEAR_SUCCESS_BANNER';

export const REPORTS_PAGINATION_CHANGE_PAGE =
  'REPORTING_PLATFORM_REPORTS_PAGINATION_CHANGE_PAGE';

export const RESET_SCHEDULED_REPORT =
  'REPORTING_PLATFORM_RESET_SCHEDULED_REPORT';

export const API_GET_SCHEDULED_REPORTS =
  'REPORTING_PLATFORM_API_GET_SCHEDULED_REPORTS';
export const API_GET_SCHEDULED_REPORTS_REQUEST =
  'REPORTING_PLATFORM_API_GET_SCHEDULED_REPORTS_REQUEST';
export const API_GET_SCHEDULED_REPORTS_SUCCESS =
  'REPORTING_PLATFORM_API_GET_SCHEDULED_REPORTS_SUCCESS';
export const API_GET_SCHEDULED_REPORTS_FAILURE =
  'REPORTING_PLATFORM_API_GET_SCHEDULED_REPORTS_FAILURE';

export const SCHEDULED_REPORTS_CHANGE_PAGE =
  'REPORTING_PLATFORM_SCHEDULED_REPORTS_CHANGE_PAGE';

export const SCHEDULED_REPORTS_CHANGE_FILTER =
  'REPORTING_PLATFORM_SCHEDULED_REPORTS_CHANGE_FILTER';

export const API_DELETE_SCHEDULED_REPORT =
  'REPORTING_PLATFORM_API_DELETE_SCHEDULED_REPORT';
export const API_DELETE_SCHEDULED_REPORT_REQUEST =
  'REPORTING_PLATFORM_API_DELETE_SCHEDULED_REPORT_REQUEST';
export const API_DELETE_SCHEDULED_REPORT_SUCCESS =
  'REPORTING_PLATFORM_API_DELETE_SCHEDULED_REPORT_SUCCESS';
export const API_DELETE_SCHEDULED_REPORT_FAILURE =
  'REPORTING_PLATFORM_API_DELETE_SCHEDULED_REPORT_FAILURE';

export const DELETE_SCHEDULED_REPORT_SET_LOADING =
  'REPORTING_PLATFORM_DELETE_SCHEDULED_REPORT_SET_LOADING';

export const DELETE_SCHEDULED_REPORT_REMOVE_LOADING =
  'REPORTING_PLATFORM_DELETE_SCHEDULED_REPORT_REMOVE_LOADING';

const reducer = (
  state = initialState,
  action: ReportingPlatformActions,
): ReportingPlatformState => {
  switch (action.type) {
    case API_GET_REPORTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    }
    case API_GET_REPORTS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    }
    case API_GET_REPORTS_SUCCESS: {
      const reports = [...(action.payload?.reports || [])].sort(
        (a, b) =>
          new Date(b.requestedAt).getTime() - new Date(a.requestedAt).getTime(),
      );
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isFirstTimeLoaded: true,
        reports,
      };
    }
    case NEW_REPORT_INIT: {
      return {
        ...state,
        newReport: {
          reportType: action.reportType,
          orderSource: action.orderSource,
          frequency: Frequencies.ONCE,
          temporaryId: action.temporaryId,
          creationType: action.creationType,
          countAllReports: action.countAllReports,
          selectedMarket: action.selectedMarket,
        },
      };
    }
    case NEW_REPORT_SET_PERIOD: {
      return {
        ...state,
        newReport: {
          ...state.newReport,
          startDate: action.startDate,
          endDate: action.endDate,
          timePeriod: action.timePeriod,
          frequency: Frequencies.ONCE,
        },
      };
    }
    case NEW_REPORT_SET_FREQUENCY: {
      return {
        ...state,
        newReport: {
          ...state.newReport,
          frequency: action.frequency,
          startDate: action.startDate,
          endDate: action.endDate,
        },
      };
    }
    case RESET_REPORT_FREQUENCY: {
      return {
        ...state,
        newReport: {
          ...state.newReport,
          frequency: undefined,
          startDate: undefined,
          endDate: undefined,
          timePeriod: undefined,
        },
      };
    }
    case NEW_REPORT_SET_SITES: {
      return {
        ...state,
        newReport: {
          ...state.newReport,
          restaurantDrnIds: action.restaurantDrnIds,
        },
      };
    }
    case NEW_REPORT_SET_RECIPIENTS: {
      return {
        ...state,
        newReport: {
          ...state.newReport,
          recipients: action.recipients,
        },
      };
    }
    case API_CREATE_REPORT_SUCCESS: {
      return {
        ...state,
        showNewReportSuccessBanner: true,
      };
    }
    case NEW_REPORT_CLEAR_SUCCESS_BANNER: {
      return {
        ...state,
        showNewReportSuccessBanner: false,
      };
    }
    case REPORTS_PAGINATION_CHANGE_PAGE: {
      return {
        ...state,
        reportsPagination: {
          currentPage: action.currentPage,
        },
      };
    }
    case RESET_REPORT: {
      return {
        ...state,
        newReport: undefined,
        reports: [],
        isLoading: false,
        isFirstTimeLoaded: false,
        reportsPagination: {
          currentPage: 1,
        },
      };
    }
    case RESET_SCHEDULED_REPORT: {
      return {
        ...state,
        scheduledReports: {
          reports: [],
          isLoading: false,
          isFirstTimeLoaded: false,
          isError: false,
          currentPage: 1,
          filter: {},
          isDeleting: {},
          isDeletingError: false,
        },
      };
    }
    case API_GET_SCHEDULED_REPORTS_REQUEST: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          isLoading: true,
          isError: false,
        },
      };
    }
    case API_GET_SCHEDULED_REPORTS_FAILURE: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          reports: [],
          isLoading: false,
          isFirstTimeLoaded: true,
          isError: true,
        },
      };
    }
    case API_GET_SCHEDULED_REPORTS_SUCCESS: {
      const reports = [...(action.payload?.scheduledReports || [])].sort(
        (a, b) =>
          new Date(b.scheduledAt).getTime() - new Date(a.scheduledAt).getTime(),
      );
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          reports,
          totalReports: action.payload.totalReports,
          isLoading: false,
          isFirstTimeLoaded: true,
        },
      };
    }
    case SCHEDULED_REPORTS_CHANGE_PAGE: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          currentPage: action.currentPage,
        },
      };
    }
    case SCHEDULED_REPORTS_CHANGE_FILTER: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          currentPage: 1,
          filter: {
            orderSource: action.orderSource,
            reportType: action.reportType,
            timePeriod: action.timePeriod,
            restaurantDrnIds: action.restaurantDrnIds,
          },
        },
      };
    }

    case API_DELETE_SCHEDULED_REPORT_REQUEST: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          isDeleting: {
            ...state.scheduledReports.isDeleting,
          },
          isDeletingError: false,
        },
      };
    }
    case API_DELETE_SCHEDULED_REPORT_FAILURE: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          isDeleting: {
            ...state.scheduledReports.isDeleting,
          },
          isDeletingError: true,
        },
      };
    }
    case API_DELETE_SCHEDULED_REPORT_SUCCESS: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          isDeleting: {
            ...state.scheduledReports.isDeleting,
          },
        },
      };
    }

    case DELETE_SCHEDULED_REPORT_SET_LOADING: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          isDeleting: {
            ...state.scheduledReports.isDeleting,
            [action.drnId]: true,
          },
        },
      };
    }
    case DELETE_SCHEDULED_REPORT_REMOVE_LOADING: {
      return {
        ...state,
        scheduledReports: {
          ...state.scheduledReports,
          isDeleting: {
            ...state.scheduledReports.isDeleting,
            [action.drnId]: false,
          },
        },
      };
    }

    case SET_DATA_FILTERS: {
      return {
        ...state,
        reportsPagination: {
          currentPage: 0,
        },
        scheduledReports: {
          ...state.scheduledReports,
          currentPage: 0,
        },
      };
    }

    default:
      return state;
  }
};

export default reducer;
